var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33333 11.606C5.46852 7.97338 8.83279 5.5 12.6387 5.5C16.4445 5.5 19.8088 7.97338 20.944 11.606L21.0671 12L20.944 12.394C19.8088 16.0266 16.4445 18.5 12.6387 18.5C8.83279 18.5 5.46852 16.0266 4.33333 12.394L4.21021 12L4.33333 11.606ZM12.6387 2.5C7.52064 2.5 2.99647 5.82613 1.46989 10.7112L1.20695 11.5526L1.06713 12L1.20695 12.4474L1.46989 13.2888C2.99647 18.1739 7.52064 21.5 12.6387 21.5C17.7567 21.5 22.2809 18.1739 23.8075 13.2888L24.0704 12.4474L24.2102 12L24.0704 11.5526L23.8075 10.7112C22.2809 5.82613 17.7567 2.5 12.6387 2.5ZM11.1387 12C11.1387 11.1716 11.8102 10.5 12.6387 10.5C13.4671 10.5 14.1387 11.1716 14.1387 12C14.1387 12.8284 13.4671 13.5 12.6387 13.5C11.8102 13.5 11.1387 12.8284 11.1387 12ZM12.6387 7.5C10.1534 7.5 8.13867 9.51472 8.13867 12C8.13867 14.4853 10.1534 16.5 12.6387 16.5C15.1239 16.5 17.1387 14.4853 17.1387 12C17.1387 9.51472 15.1239 7.5 12.6387 7.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.f60c062d1905949c2e45bead9eddc8e6.svg";
export { ForwardRef as ReactComponent };